export default __webpack_public_path__ + "static/ai-d74dae528c029f58c73b670369729cad.svg";